import PaintLeadsWorkspacePlaceholder from '../../placeholders/PaintLeadsWorkspacePlaceholder';

export default PaintLeadsWorkspacePlaceholder;
